import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/home1/newsletter-mailbox.png';
import _imports_1 from '@/assets/home1/newsletter-envelope.png';
const _withScopeId = n => (_pushScopeId("data-v-519c826f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-newsletter",
  "aria-labelledby": "newsletter-title"
};
const _hoisted_2 = {
  class: "newsletter-shell"
};
const _hoisted_3 = {
  class: "newsletter-panel"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "newsletter-mailbox",
  src: _imports_0,
  alt: "",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_5 = {
  class: "newsletter-copy"
};
const _hoisted_6 = {
  id: "newsletter-title"
};
const _hoisted_7 = ["onSubmit"];
const _hoisted_8 = {
  class: "sr-only",
  for: "newsletter-email"
};
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = {
  type: "submit"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "newsletter-envelope",
  src: _imports_1,
  alt: "",
  "aria-hidden": "true"
}, null, -1));
import { ref } from 'vue';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'HomeNewsletter',
  setup(__props) {
    const router = useRouter();
    const {
      t
    } = useI18n();
    const email = ref('');
    const goToRegister = () => {
      const query = email.value.trim() ? {
        email: email.value.trim()
      } : undefined;
      router.push({
        name: 'register',
        query
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(t)('homepage.newsletter.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('homepage.newsletter.description')), 1)]), _createElementVNode("form", {
        class: "newsletter-form",
        onSubmit: _withModifiers(goToRegister, ["prevent"])
      }, [_createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)('homepage.newsletter.emailLabel')), 1), _withDirectives(_createElementVNode("input", {
        id: "newsletter-email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => email.value = $event),
        type: "email",
        placeholder: _unref(t)('homepage.newsletter.emailPlaceholder'),
        autocomplete: "email"
      }, null, 8, _hoisted_9), [[_vModelText, email.value]]), _createElementVNode("button", _hoisted_10, [_createTextVNode(_toDisplayString(_unref(t)('homepage.newsletter.createAccount')) + " ", 1), _createVNode(_unref(ArrowRightOutlined), {
        "aria-hidden": "true"
      })])], 40, _hoisted_7), _hoisted_11])])]);
    };
  }
};